import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    VerifyEmailLandingRoute: {
        to: "/verify-email",
        build: (options) => interpolatePath("/verify-email", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    LandingRoute: {
        to: "/landing",
        build: (options) => interpolatePath("/landing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AppLayoutRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    DashboardRoute: {
        to: "/dashboard",
        build: (options) => interpolatePath("/dashboard", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    DiscoverRoute: {
        to: "discover",
        build: (options) => interpolatePath("discover", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    MyRecipesRoute: {
        to: "my-recipes",
        build: (options) => interpolatePath("my-recipes", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RecipeManagerRoute: {
        to: "manager",
        build: (options) => interpolatePath("manager", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    FavoritesRoute: {
        to: "favorites",
        build: (options) => interpolatePath("favorites", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    SharedRecipeRoute: {
        to: "recipes/shared/:shareSlug",
        build: (options) => interpolatePath("recipes/shared/:shareSlug", options.params, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PlansRoute: {
        to: "plans",
        build: (options) => interpolatePath("plans", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    ShoppingListRoute: {
        to: "/shopping-list",
        build: (options) => interpolatePath("/shopping-list", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    ComingSoonRoute: {
        to: "/coming-soon",
        build: (options) => interpolatePath("/coming-soon", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    NutritionRoute: {
        to: "/nutrition",
        build: (options) => interpolatePath("/nutrition", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RecipeDetailRoute: {
        to: "recipe/:id",
        build: (options) => interpolatePath("recipe/:id", options.params, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    CookingModeRoute: {
        to: "cook/:recipeId",
        build: (options) => interpolatePath("cook/:recipeId", options.params, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RecipeRedirectRoute: {
        to: "recipe",
        build: (options) => interpolatePath("recipe", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    CreateCustomRecipeRoute: {
        to: "create-recipe",
        build: (options) => interpolatePath("create-recipe", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    SemanticSearchTestRoute: {
        to: "semantic-search-test",
        build: (options) => interpolatePath("semantic-search-test", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    ProfileRoute: {
        to: "/profile",
        build: (options) => interpolatePath("/profile", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    KitchenProfileRoute: {
        to: "/profile/kitchen",
        build: (options) => interpolatePath("/profile/kitchen", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    BillingRoute: {
        to: "/billing",
        build: (options) => interpolatePath("/billing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AccountBillingRoute: {
        to: "/account/billing",
        build: (options) => interpolatePath("/account/billing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    SettingsRoute: {
        to: "/settings",
        build: (options) => interpolatePath("/settings", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PricingRoute: {
        to: "pricing",
        build: (options) => interpolatePath("pricing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    BetaPricingRoute: {
        to: "beta-pricing",
        build: (options) => interpolatePath("beta-pricing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminUsageRoute: {
        to: "admin/usage",
        build: (options) => interpolatePath("admin/usage", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminPlansRoute: {
        to: "admin/plans",
        build: (options) => interpolatePath("admin/plans", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminBillingRoute: {
        to: "admin/billing",
        build: (options) => interpolatePath("admin/billing", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminAIRoute: {
        to: "admin/ai",
        build: (options) => interpolatePath("admin/ai", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminSystemRoute: {
        to: "admin/system",
        build: (options) => interpolatePath("admin/system", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminSystemHealthRoute: {
        to: "admin/system-health",
        build: (options) => interpolatePath("admin/system-health", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminEventsRoute: {
        to: "admin/events",
        build: (options) => interpolatePath("admin/events", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminFeatureFlagsRoute: {
        to: "admin/feature-flags",
        build: (options) => interpolatePath("admin/feature-flags", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminIngredientUnitsRoute: {
        to: "admin/ingredient-units",
        build: (options) => interpolatePath("admin/ingredient-units", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminApiDocsRoute: {
        to: "admin/api-docs",
        build: (options) => interpolatePath("admin/api-docs", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminSemanticDiscoveryRoute: {
        to: "admin/semantic-discovery",
        build: (options) => interpolatePath("admin/semantic-discovery", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminRetentionRoute: {
        to: "admin/retention-insights",
        build: (options) => interpolatePath("admin/retention-insights", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RetentionInsightsRoute: {
        to: "admin/retention-insights",
        build: (options) => interpolatePath("admin/retention-insights", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    NavDemoRoute: {
        to: "nav-demo",
        build: (options) => interpolatePath("nav-demo", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    RecipeExperienceRoute: {
        to: "recipe-demo",
        build: (options) => interpolatePath("recipe-demo", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    Receipt2RecipeRoute: {
        to: "features/receipt2recipe",
        build: (options) => interpolatePath("features/receipt2recipe", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    TermsRoute: {
        to: "legal/terms",
        build: (options) => interpolatePath("legal/terms", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PrivacyRoute: {
        to: "legal/privacy",
        build: (options) => interpolatePath("legal/privacy", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    OnboardingRoute: {
        to: "/onboarding",
        build: (options) => interpolatePath("/onboarding", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    TasksRoute: {
        to: "tasks",
        build: (options) => interpolatePath("tasks", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    PlanDetailRoute: {
        to: "plans/:planId",
        build: (options) => interpolatePath("plans/:planId", options.params, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminRoute: {
        to: "admin",
        build: (options) => interpolatePath("admin", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminOverview: {
        to: "admin/overview",
        build: (options) => interpolatePath("admin/overview", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminRevenue: {
        to: "admin/revenue",
        build: (options) => interpolatePath("admin/revenue", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminScrapedRecipesRoute: {
        to: "admin/scraped-recipes",
        build: (options) => interpolatePath("admin/scraped-recipes", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    HouseholdRoute: {
        to: "household",
        build: (options) => interpolatePath("household", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdHocCostingRoute: {
        to: "/ims/costing/adhoc",
        build: (options) => interpolatePath("/ims/costing/adhoc", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminUsageManagementRoute: {
        to: "/admin/usage-management",
        build: (options) => interpolatePath("/admin/usage-management", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    BetaLandingRoute: {
        to: "/beta",
        build: (options) => interpolatePath("/beta", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
    AdminBetaWaitlistRoute: {
        to: "/admin/beta-waitlist",
        build: (options) => interpolatePath("/admin/beta-waitlist", undefined, options === null || options === void 0 ? void 0 : options.search, options === null || options === void 0 ? void 0 : options.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map